import firebase from 'firebase/app';
import 'firebase/firestore';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { Button } from '../components/Button';
import { Input } from '../components/Input';
import { PlayAgainButton } from '../components/PlayAgainButton';
import { View } from '../components/View';
import { useGameStore } from '../hooks/useGameStore';

type FormInputs = {
  name: string;
  company: string;
};

export function GameOverView() {
  const [score, player, nextView] = useGameStore(
    useCallback((state) => [state.score, state.playerName, state.nextView], [])
  );
  const { register, handleSubmit } = useForm<FormInputs>();

  function handleOnSubmit(values: FormInputs) {
    firebase
      .firestore()
      .collection('highscores')
      .add({
        score,
        player,
        name: values.name,
        company: values.company,
      })
      .then((response) => {
        nextView();
      })
      .catch((error) => console.log({ error }));
  }

  return (
    <View title="Bra jobbat!">
      <span className="block text-center text-gray-800 mb-8">{score} p</span>

      <form className="space-y-8" onSubmit={handleSubmit(handleOnSubmit)}>
        <div className="w-80 space-y-4">
          <Input {...register('name')} autoComplete="off" placeholder="Namn" />
          <Input
            {...register('company', { required: true })}
            autoComplete="off"
            placeholder="Företag"
          />
        </div>

        <div className="text-center">
          <Button>Topplistan</Button>
        </div>
      </form>
      <PlayAgainButton />
    </View>
  );
}
